export type WarningVisualProps = {
  width?: number;
};

export function WarningVisual({ width }: WarningVisualProps): JSX.Element {
  const w = width || 257;
  const h = width ? (232 / 257) * width : 232;
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 257 232`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_208_773)">
        <path
          d="M132.295 31.2253C139.47 20.0211 155.839 20.0211 163.014 31.2253L190.196 73.6742C197.97 85.8137 189.252 101.748 174.837 101.748H120.472C106.057 101.748 97.3395 85.8137 105.113 73.6742L132.295 31.2253Z"
          fill="url(#paint0_linear_208_773)"
        />
        <g filter="url(#filter1_bi_208_773)">
          <path
            d="M110.451 21.8437C117.635 10.7188 133.908 10.7188 141.093 21.8436L184.701 89.3666C192.539 101.503 183.827 117.5 169.38 117.5H82.163C67.716 117.5 59.0041 101.503 66.8419 89.3666L110.451 21.8437Z"
            fill="url(#paint1_linear_208_773)"
          />
          <path
            d="M111.133 22.2845C117.998 11.6552 133.545 11.6552 140.41 22.2844L184.019 89.8074C191.507 101.403 183.184 116.688 169.38 116.688H82.163C68.3596 116.688 60.0358 101.403 67.5244 89.8074L111.133 22.2845Z"
            stroke="url(#paint2_linear_208_773)"
            strokeWidth="1.625"
          />
        </g>
        <path
          d="M160.277 51.5489C148.931 62.3078 132.474 73.778 108.608 84.5065C90.9139 92.4608 77.2245 100.755 66.6336 108.827C63.1751 103.198 62.7204 95.7483 66.8419 89.3666L110.451 21.8437C117.635 10.7188 133.908 10.7188 141.093 21.8436L160.277 51.5489Z"
          fill="white"
          fillOpacity="0.09"
        />
        <g filter="url(#filter2_d_208_773)">
          <path
            d="M126.556 44.546C123.433 44.546 120.954 47.1765 121.14 50.2945L122.668 75.9625C122.781 77.8735 124.364 79.365 126.279 79.365H127.752C129.666 79.365 131.249 77.8735 131.363 75.9625L132.891 50.2945C133.076 47.1765 130.598 44.546 127.474 44.546H126.556Z"
            fill="url(#paint3_linear_208_773)"
          />
          <path
            d="M126.073 85.1681C124.075 85.1681 122.456 86.7877 122.456 88.7855V89.841C122.456 91.8388 124.075 93.4584 126.073 93.4584H127.128C129.126 93.4584 130.746 91.8388 130.746 89.841V88.7855C130.746 86.7877 129.126 85.1681 127.128 85.1681H126.073Z"
            fill="url(#paint4_linear_208_773)"
          />
          <path
            d="M121.951 50.2462C121.793 47.5951 123.9 45.3585 126.556 45.3585H127.474C130.13 45.3585 132.237 47.5951 132.08 50.2462L130.552 75.9142C130.464 77.396 129.236 78.5525 127.752 78.5525H126.279C124.794 78.5525 123.567 77.396 123.479 75.9143L121.951 50.2462ZM123.268 88.7855C123.268 87.2364 124.524 85.9806 126.073 85.9806H127.128C128.677 85.9806 129.933 87.2364 129.933 88.7855V89.841C129.933 91.3901 128.677 92.6459 127.128 92.6459H126.073C124.524 92.6459 123.268 91.3901 123.268 89.841V88.7855Z"
            stroke="white"
            strokeOpacity="0.14"
            strokeWidth="1.625"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_208_773"
          x="0.519531"
          y="0.5"
          width="255.961"
          height="230.75"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="50.375" />
          <feGaussianBlur stdDeviation="31.6875" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.435294 0 0 0 0 0.294118 0 0 0 0 0.894118 0 0 0 0.21 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_208_773"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_208_773"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_bi_208_773"
          x="46.8945"
          y="-3.5"
          width="157.754"
          height="138"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="8.5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_208_773"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_208_773"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_208_773"
          />
        </filter>
        <filter
          id="filter2_d_208_773"
          x="115.13"
          y="44.546"
          width="23.7705"
          height="60.9124"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.635294 0 0 0 0 0.294118 0 0 0 0 0.894118 0 0 0 0.27 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_208_773"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_208_773"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_208_773"
          x1="85.3036"
          y1="63.8985"
          x2="104.995"
          y2="7.13498"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#844AE3" />
          <stop offset="1" stopColor="#E14AE3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_208_773"
          x1="125.772"
          y1="13.5"
          x2="125.772"
          y2="119.901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AB4BE4" stopOpacity="0.42" />
          <stop offset="1" stopColor="#E14BE4" stopOpacity="0.49" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_208_773"
          x1="89.3487"
          y1="32.507"
          x2="139.454"
          y2="135.462"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.331091" stopColor="white" stopOpacity="0.26" />
          <stop offset="1" stopColor="#AB4BE4" stopOpacity="0.16" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_208_773"
          x1="120.826"
          y1="79.9402"
          x2="133.348"
          y2="79.9249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9C7FC" />
          <stop offset="1" stopColor="#FEFCFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_208_773"
          x1="120.826"
          y1="79.9402"
          x2="133.348"
          y2="79.9249"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E9C7FC" />
          <stop offset="1" stopColor="#FEFCFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
